import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { ISwipeableDrawerCustom as IBottomDrawer } from '../../interfaces';
import Avatar from '@mui/material/Avatar';
import InfoIcon from '@mui/icons-material/Info';
import { IconButton } from '@mui/material';

import { Typography } from '@mui/material';
import MobileBottomDrawer from './MobileBottomDrawer.component';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import DesktopBottomDrawer from './DesktopBottomDrawer.component';
import PieChartTreeType from '../Charts/PieChartTreeType.component';
import BarChartForestStatus from '../Charts/BarChartForestStatus.component'
import { useState } from 'react';
import InfoPopup from './InfoPopup';
import useTranslation from '../../Language/useTranslation';


export default function ContentBottomDrawer(props: IBottomDrawer) {
    const theme = useTheme();
    const mobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [infoPopupOpen, setInfoPopupOpen] = useState(false);

    const t = useTranslation();

    function handleInfoClicked() {
        setInfoPopupOpen(true)
    }

    const getBundeslandNameByLabel = (label: string) => {

        const result = t.bundeslaenderList.find(bundesland => bundesland.label === label);
        return result ? result.name : 'Label not found';
    };

    const content = (
        <>
            <InfoPopup setOpen={setInfoPopupOpen} open={infoPopupOpen} />
            <Box
                sx={{
                    pt: 1,
                    px: 2,
                    pb: 3,
                    height: '100%',
                    overflow: 'auto',
                    backgroundColor: 'customBackground.main',
                }}
            >
                <Box sx={{ m: 2 }}>
                    <Typography variant="h4">
                        {
                            getBundeslandNameByLabel(props.statisticsBundesland.label)
                        }
                    </Typography>
                    <Typography variant="body1" color="text.secondary">
                        {Math.round(props.statisticsBundesland.waldfläche2017Ha).toLocaleString("DE")} ha {t.namesUIElements.sublineBundesland.name}
                    </Typography>
                </Box>
                <Grid container spacing={2} direction="row">
                    <Grid item xs={12} md={6}  >
                        <Card square={true} sx={{ height: "100%" }}>
                            <CardContent>
                                <Typography variant="h6" color="text.secondary">
                                    {t.namesUIElements.baumartenPieChart.name}
                                </Typography>
                                {/* <Grid container direction="row" justifyContent={"flex-start"}> */}
                                <PieChartTreeType statisticsBundesland={props.statisticsBundesland} />
                                {/* </Grid> */}
                            </CardContent>

                        </Card>
                    </Grid>

                    <Grid container item xs={12} md={6} direction="column" sx={{ height: "100%" }}>

                        <Card square={true}>
                            <CardContent>
                                <Typography variant="h6" color="text.secondary">
                                    {t.namesUIElements.schadflaechenBarChart.name}
                                    {/* <IconButton sx={{ color: "text.secondary" }} onClick={handleInfoClicked}>
                                        <InfoIcon />
                                    </IconButton> */}
                                </Typography>
                                {/* <Grid container direction="row" justifyContent={"flex-start"}> */}
                                <BarChartForestStatus statisticsBundesland={props.statisticsBundesland} />
                                {/* </Grid> */}
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
                {/* <Skeleton variant="rectangular" height="100%" /> */}
            </Box>
        </>
    );



    return (
        <>
            {mobile ?
                <MobileBottomDrawer
                    open={props.bottomDrawerOpen}
                    setOpen={props.setBottomDrawerOpen}
                >
                    {content}
                </MobileBottomDrawer>
                :
                <DesktopBottomDrawer
                    open={props.bottomDrawerOpen}
                    setOpen={props.setBottomDrawerOpen}
                >
                    {content}
                </DesktopBottomDrawer>
            }
        </>

    )
        ;
}

// function StatsCardText(props: any) {
//     return (

//         <CardContent >
//             <Grid container >
//                 <Grid item xs={9}>
//                     <Typography variant="h6" color="text.secondary">
//                         {props.card.header}
//                     </Typography>
//                     <Typography gutterBottom variant="h4" component="div">
//                         {props.card.infoLine}
//                     </Typography>
//                     <Typography variant="body2" color="text.secondary">
//                         {props.card.footer}
//                     </Typography>
//                 </Grid>
//                 <Grid item xs={3}>
//                     <Avatar sx={{ bgcolor: props.card.color }}>
//                         {props.card.icon}
//                     </Avatar>
//                 </Grid>
//             </Grid>
//         </CardContent>
//     )
// }